"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.esEpisodeVideoStencil = exports.episodeVideoStencilDefinition = void 0;
const properties_1 = require("../properties");
const episode_number_property_1 = require("../properties/episode-number.property");
const season_property_1 = require("../properties/season.property");
const rbtvContentAreas = [
    {
        name: 'main',
        items: [
            'title',
            'subheading',
            'teaser',
            'description',
            'epg-description',
            'mediabase-essence',
            'video-markers',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'epg-title',
                    'uri-title',
                    'url',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'season',
                    'episode-number',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'no-embedding',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-teams',
            'related-content',
        ],
    },
];
exports.episodeVideoStencilDefinition = {
    view: {
        label: 'Episode video',
        group: 'Moving images',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'subheading',
                    'teaser',
                    'description',
                    'mediabase-essence',
                    'video-markers',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'epg-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'social-media-image',
                            'featured-video',
                            'geolocation',
                            'season',
                            'episode-number',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'no-embedding',
                            'standalone',
                            'no-monetization',
                            'sponsored-by',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'epg-description': properties_1.epgDescriptionPropertyDefinition,
        'epg-title': properties_1.epgTitlePropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
        'content-classification-terms': properties_1.contentClassificationTermsPropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        description: properties_1.descriptionPropertyDefinition,
        'cta-container': properties_1.ctaContainerPropertyDefinition,
        'episode-number': episode_number_property_1.episodeNumberPropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'social-media-image': properties_1.socialMediaImagePropertyDefinition,
        'featured-video': {
            ...properties_1.featuredVideoPropertyDefinition,
            view: {
                label: 'Featured video',
                style: '',
                hint: 'Used to represent the content piece on collection pages.',
                hintAdditional: 'If there is a preview clip available it will be automatically embedded here after publishing. Please notice it may take a few minutes upon publishing before the preview clip will show.',
            },
        },
        geolocation: properties_1.geolocationPropertyDefinition,
        'mediabase-essence': properties_1.mediabaseEssencePropertyDefinition,
        'video-markers': properties_1.videoMarkersPropertyDefinition,
        disciplines: properties_1.disciplinesPropertyDefinition,
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        subheading: properties_1.subheadingPropertyDefinition,
        season: season_property_1.seasonPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        standalone: properties_1.standalonePropertyDefinition,
        'no-monetization': properties_1.noMonetizationPropertyDefinition,
        'no-embedding': properties_1.noEmbeddingPropertyDefinition,
        url: properties_1.urlPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        'sponsored-by': properties_1.sponsoredByPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'brand-building-events',
        'media-partnerships',
        'racing-bulls',
        'rbtv',
        'rbtv_temporary',
        'redbull-racing',
    ],
    name: 'episode-video',
    overwrites: [
        {
            condition: 'space',
            argument: 'rbtv',
            contentAreas: rbtvContentAreas,
        },
    ],
};
const esEpisodeVideoStencil = (stencil) => {
    return stencil.name === exports.episodeVideoStencilDefinition.name;
};
exports.esEpisodeVideoStencil = esEpisodeVideoStencil;
//# sourceMappingURL=data:application/json;base64,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